import { createSlice } from "@reduxjs/toolkit";

const initialState: EasiRechargeState = {
  mobileNumber: "",
  package: {
    id: 0,
    code: "",
    price: "",
  },
};

export const easiRechargeSlice = createSlice({
  name: "easi-recharge",
  initialState,
  reducers: {
    setEasiRecharge: (state, action) => {
      Object.assign(state, action.payload);
    },
    resetEasiRecharge: () => initialState,
  },
});

export const { setEasiRecharge, resetEasiRecharge } = easiRechargeSlice.actions;
export default easiRechargeSlice.reducer;
